export class UserLoginDto {
  userName: string = '';
  password: string = '';
  isValid: boolean;
}
